$(function(){
	if ($('.mypage.index').length > 0){
		// 本人確認依頼OKクリック
		$(document).on(oEventNames.end, '#modal-confirm .btn-ok', function (event) {
			if (!bIsScrolling) {
				event.preventDefault();
				window.location.href = '/mypage/request-identification';
			}
		});
	}
});

if ($('#js-copy').length) {
	// コピーボタン
	const btn_copy = document.querySelector('#js-copy');
	// コピー対象となるテキスト
	const copy_target = document.querySelector('#target');

	// コピーボタンのクリックイベント
	btn_copy.addEventListener('click', () => {
	copyText(copy_target);
	});

	const copyText = (target) => {
	// テキストの選択
	document.getSelection().selectAllChildren(target);
	// 選択範囲のコピー
	document.execCommand("copy");
	// テキスト選択の解除
	document.getSelection().empty(target);
	}
	$(function(){
		$('#js-copy').click(function(){
				$(this).addClass('copied');    //ボタンの色などを変更するためにクラスを追加
				$(this).text('コピーしました');    //テキストの書き換え
			});
		});
}
